/* eslint-disable import/no-unresolved */

import { MetaHelmet } from 'layouts/Helmet/Helmet';
import { useDevice } from 'hooks/useResponsive';

import EstimatePageMobile from './Estimatemobile';
import EstimatePageWeb from './EstimateWeb';

export default function Estimate() {
  const { isMobile } = useDevice();

  return (
    <div id="estimate_top" style={{ overflowX: 'clip' }}>
      <MetaHelmet title={'Estimate'} companyName={'ZealCurtains'} />
      {isMobile ? <EstimatePageMobile /> : <EstimatePageWeb />}
    </div>
  );
}
